import React from 'react';
import { Hero } from '../components/Hero';
import { ConfrontationSection } from '../components/ConfrontationSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TransformationSection } from '../components/TransformationSection';
import { TargetAudience } from '../components/TargetAudience';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { InstructorsSection } from '../components/InstructorsSection';
import { CTASection } from '../components/CTASection';
export function LandingPage() {
  return <main className="min-h-screen bg-white text-slate-900 selection:bg-amber-200" data-id="element-219">
      <Hero data-id="element-220" />
      <ConfrontationSection data-id="element-221" />
      <BenefitsSection data-id="element-222" />
      <TransformationSection data-id="element-223" />
      <TargetAudience data-id="element-224" />
      <TestimonialsSection data-id="element-225" />
      <CTASection data-id="element-226" />
      <InstructorsSection data-id="element-227" />

      {/* Footer / Final CTA */}
      <footer className="bg-slate-50 py-12 border-t border-slate-200 text-center text-slate-500 text-sm" data-id="element-228">
        <div className="max-w-7xl mx-auto px-4" data-id="element-229">
          <p data-id="element-230">© 2025 Juega desde Otro Nivel. Todos los derechos reservados.</p>
        </div>
      </footer>
    </main>;
}